import { useTheme } from '@mui/material/styles';
import { Box, Card, CardHeader, List, ListItemText, Paper, Typography } from '@mui/material';
// import IconButton from "components/@extended/IconButton";

// project import

// assets
// import { CloseOutlined } from "@ant-design/icons";

// sx styles
const avatarSX = {
	width: 36,
	height: 36,
	fontSize: '.75rem',
};

const actionSX = {
	mt: '6px',
	ml: 1,
	top: 'auto',
	right: 'auto',
	alignSelf: 'flex-start',

	transform: 'none',
};

const ErrorModal = ({ modalData }) => {
	const theme = useTheme();

	const cardHeaderSX = {
		// backgroundColor: "#00914f",
		backgroundColor: theme.palette.lynTheme.delete,
		color: '#ffff',
	};

	console.log(modalData, 'modal data');

	return (
		<Box sx={{ flexShrink: 0 }}>
			<Paper
				sx={{
					boxShadow: theme.customShadows.z1,
					minWidth: 400,
					maxWidth: 600,
					borderRadius: '8px',
					[theme.breakpoints.down('md')]: {
						minWidth: 200,
						maxWidth: 285,
						// margin: "0 10px",
					},
				}}
			>
				<Card
					elevation={0}
					sx={{
						position: 'relative',
						borderRadius: '8px',
					}}
				>
					<CardHeader titleTypographyProps={{ variant: 'subtitle1' }} title="Errors" sx={cardHeaderSX} />
					<List
						component="nav"
						sx={{
							width: '100%',
							maxWidth: 400,
							minHeight: 150,
							maxHeight: 300,
							// bgcolor: "background.paper",
							position: 'relative',
							overflow: 'auto',
							scrollbarWidth: 'thin',
							'&::-webkit-scrollbar': {
								width: '6px',
							},
							'&::-webkit-scrollbar-thumb': {
								backgroundColor: '#aeb0b0',
								borderRadius: '6px',
							},
							p: 0,
							'& .MuiListItemButton-root': {
								py: 0.5,
								'& .MuiAvatar-root': avatarSX,
								'& .MuiListItemSecondaryAction-root': { ...actionSX, position: 'relative' },
							},
							// [theme.breakpoints.down("md")]: {
							//   maxHeight: 450,
							// },
						}}
					>
						<Box>
							{modalData?.map((value, index) => (
								<ListItemText
									sx={{ padding: '10px' }}
									key={index}
									primary={
										<Typography>
											<Typography variant="span" sx={{ fontWeight: 700 }}>
												{value?.field} :
											</Typography>{' '}
											{value?.message}
										</Typography>
									}
								/>
							))}
						</Box>
					</List>
				</Card>
			</Paper>
		</Box>
	);
};

export default ErrorModal;
